// @flow
import cn from 'classnames';
import React, { useState, Fragment } from 'react';

import * as DataId from '../dataIds';
import { BurgerMenuIcon } from './BurgerMenuIcon';
import './style.pcss';

type Props = {|
  sections: React$Node[]
|};

export const BurgerMenu = ({
  sections
}: Props) => {
  const [isOpenMenu, setOpenMenu] = useState(false);

  if (!sections.length) {
    return null;
  }

  const openBurgerMenu = () => {
    setOpenMenu(!isOpenMenu);
  };

  return (
    <>
      <BurgerMenuIcon
        onClick={openBurgerMenu}
        isCross={isOpenMenu}
      />
      <div
        className={cn(
          'burger-menu',
          { 'burger-menu--hidden': !isOpenMenu }
        )}
        data-id={DataId.BURGER_MENU_LIST}
      >
        {sections.map((child, index) => (
          // sections is immutable array (indexes didn't change)
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>
            {index !== 0 && <hr className='burger-menu__section-line' />}
            <div className='burger-menu__section'>
              {child}
            </div>
          </Fragment>
        ))}
      </div>
    </>
  );
};
